import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { toast } from 'react-toastify';
import { getDashboardData } from '../services/dashboardApi';
import { getTodayTeacherClasses } from "../services/TeacherApi";
import LoadingSpinner from './LoadingSpinner';
import config from '../config/config';

const TeacherDashboard = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [programs, setProgramData] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetchDashboardData();
    fetchTodayData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const dashboardData = await getDashboardData();
      setNotices(dashboardData.data.notices || []);

    } catch (error) {
      toast.error("Failed to fetch dashboard data");
    } finally {
      setLoading(false);
    }
  };

  const fetchTodayData = async () => {
    try {
      const response = await getTodayTeacherClasses(user.user_data.id);
      setProgramData(response.data || []);
    } catch (error) {
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }


  var programsview = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 2, initialSlide: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } }
    ]
  };



  return (
    <div className='app-container mobile-bottom'>
      <Container>

        <h2 className='fs-20 fw-6'>
          <span className='small-hello fs-14'>Hello, </span>
          <span className='bigg-name'>{user?.user_data.name}!</span>
        </h2>
        <div className='program-we-offer'>
          <div className='mt-4 d-flex justify-content-between align-items-center'>
            <div>
              <h2 className='fs-20 fw-6 mb-1'>Today's Classes</h2>
            </div>
            <div>
              <Link to='/allocatedClasses' className='text-info text-decoration-none fs-10'>Know More</Link>
            </div>
          </div>
          <Slider className='single-items mt-3' {...programsview}>
            {programs.map((program, index) => (
              <div className='imag-title position-relative' key={index}>
                <Link to={`/attendanceTeacher/${program.program_id}`}
                  state={{ programId: program.program_id, skillLevelId: program.skill_level_id }} className="text-decoration-none text-dark">
                  <h3>{program.program_name}</h3>
                  <img src={`${config.Image_Base_URL}${program.program_image}`} className="w-100 pro_image" alt="music" />
                  <div className="text-center fs-13 mt-2">
                    <p className="mb-0">{program.focus_title} - {program.skill_level_name} Level</p>
                    <p className="mb-0">{program.start_time} - {program.end_time}</p>
                    <p className="mb-0">{program.today_day}</p>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </div>

        {/* NOTICE BOARD */}
        {notices.length > 0 && (
          <div className='notice-board mt-5'>
            <h1 className='mt-4 fs-20 fw-6'>Upcoming Events & Notices</h1>
            <Row className='mb-3'>
              <Col xs='12'>
                <div className='border-black border p-4 rounded'>
                  <p dangerouslySetInnerHTML={{ __html: notices[0].notice_text }} />
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Container >
    </div >
  );
}

export default TeacherDashboard;
